import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
export const EndInterviewWarningModal = ({ visible, onConfirm, onCancel, loading = false, }) => {
    if (!visible) {
        return null;
    }
    return (_jsx("div", Object.assign({ style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
        } }, { children: _jsxs("div", Object.assign({ style: {
                background: "#FFF",
                padding: "40px 20px",
                textAlign: "center",
                minHeight: "280px",
                maxWidth: "520px",
                width: "90%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                boxShadow: "0 20px 24px -4px rgba(10, 13, 18, 0.14), 0 8px 8px -4px rgba(10, 13, 18, 0.08)",
            } }, { children: [_jsx("div", Object.assign({ style: {
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        background: "#ffeef5",
                        border: "2px solid #ff4d4f",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                    } }, { children: _jsx(ExclamationCircleOutlined, { style: {
                            fontSize: "40px",
                            color: "#ff4d4f",
                        } }) })), _jsx("h2", Object.assign({ style: {
                        color: "#ff4d4f",
                        fontWeight: "bold",
                        fontSize: "24px",
                        marginBottom: "16px",
                        marginTop: "0",
                    } }, { children: "End Interview?" })), _jsx("p", Object.assign({ style: {
                        color: "#333",
                        fontSize: "16px",
                        marginBottom: "16px",
                        maxWidth: "480px",
                    } }, { children: "Are you sure you want to end the interview?" })), _jsx("div", Object.assign({ style: {
                        background: "#fff1f0",
                        border: "2px solid #ff4d4f",
                        borderRadius: "8px",
                        padding: "16px 20px",
                        marginBottom: "24px",
                        maxWidth: "480px",
                        width: "100%",
                    } }, { children: _jsx("p", Object.assign({ style: {
                            color: "#ff4d4f",
                            fontSize: "18px",
                            fontWeight: "bold",
                            margin: "0",
                            lineHeight: "1.5",
                        } }, { children: "\u26A0\uFE0F You will NOT be able to start the interview again." })) })), _jsxs("div", Object.assign({ style: {
                        display: "flex",
                        gap: "12px",
                        marginTop: "8px",
                        flexWrap: "wrap",
                        justifyContent: "center",
                    } }, { children: [_jsx(Button, Object.assign({ type: "primary", danger: true, onClick: onConfirm, loading: loading, disabled: loading, style: {
                                backgroundColor: "#ff4d4f",
                                borderColor: "#ff4d4f",
                                borderRadius: "8px",
                                padding: "8px 20px",
                                height: "auto",
                                fontSize: "14px",
                                fontWeight: 500,
                                boxShadow: "none",
                            }, onMouseEnter: (e) => {
                                if (!loading) {
                                    e.currentTarget.style.backgroundColor = "#ff7875";
                                    e.currentTarget.style.borderColor = "#ff7875";
                                    e.currentTarget.style.boxShadow = "none";
                                }
                            }, onMouseLeave: (e) => {
                                if (!loading) {
                                    e.currentTarget.style.backgroundColor = "#ff4d4f";
                                    e.currentTarget.style.borderColor = "#ff4d4f";
                                    e.currentTarget.style.boxShadow = "none";
                                }
                            } }, { children: "Yes, end interview" })), _jsx(Button, Object.assign({ onClick: onCancel, disabled: loading, style: {
                                backgroundColor: "#ffffff",
                                borderColor: "#d9d9d9",
                                color: "#333333",
                                borderRadius: "8px",
                                padding: "8px 20px",
                                height: "auto",
                                fontSize: "14px",
                                fontWeight: 500,
                                boxShadow: "none",
                            }, onMouseEnter: (e) => {
                                if (!loading) {
                                    e.currentTarget.style.backgroundColor = "#fafafa";
                                    e.currentTarget.style.borderColor = "#d9d9d9";
                                    e.currentTarget.style.color = "#333333";
                                    e.currentTarget.style.boxShadow = "none";
                                }
                            }, onMouseLeave: (e) => {
                                if (!loading) {
                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                    e.currentTarget.style.borderColor = "#d9d9d9";
                                    e.currentTarget.style.color = "#333333";
                                    e.currentTarget.style.boxShadow = "none";
                                }
                            } }, { children: "Continue interview" }))] }))] })) })));
};
